<template>
    <CardWrap v-bind="$props" class="CardRating">
        <textarea
            v-model="text"
            placeholder="Enter text (max length: 640)"
            class="fci-scrollbar"
            @focusout="save"
            maxlength="640"
        ></textarea>
        <CardButtonList
            :card="card"
            v-model="buttonList"
            @save="save"
        ></CardButtonList>
    </CardWrap>
</template>
<script>
import CardBase from '@/views/Scenario/StepEditor/Card/component/CardBase'
import CardButtonList from '@/views/Scenario/StepEditor/Card/component/CardButtonList'

export default {
    name: 'CardRatingAgent',
    components: { CardButtonList },
    extends: CardBase,
    data () {
        let config = this.card.config
        if (!config.buttons) {
            this.card.config.buttons = []
        }
        return {
            text: config.text,
            buttonList: this.$ut.cloneObject(config.buttons ? config.buttons : '[]')
        }
    },
    methods: {
        getNewConfig () {
            return {
                ...this.card.config,
                text: this.text,
                buttons: this.buttonList
            }
        }
    }
}
</script>
<style scoped>

</style>
